import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress'
import { styled } from '../../utils/styled'

export const StyledLinearProgressGlobalLoader = styled(LinearProgress)(({ theme }) => ({
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '4px',
  zIndex: 1300,
  backgroundColor: theme.tokens.background.semantic.info.tonal.superSoft.default,
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: theme.borderRadius.xSmall,
    backgroundColor: theme.tokens.background.brand.main.default,
    transitionDuration: '5s'
  }
}))
